import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICliente, IToken, IUsuario, TipoDispositivo } from 'modelos/src';
import { Observable } from 'rxjs';
import { apiBase } from '../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient) { }

  public static isLogged() {
    if (sessionStorage.getItem('token')) {
      return true;
    }
    return false;
  }

  public static getToken() {
    return sessionStorage.getItem('token') || '';
  }

  public static getRefreshToken(): string {
    return sessionStorage.getItem('refreshToken') || '';
  }

  public static getUsuario(): IUsuario {
    const user = sessionStorage.getItem('usuario');
    return user ? JSON.parse(user) : undefined;
  }

  public static getCliente(): ICliente | undefined {
    const cliente = sessionStorage.getItem('cliente');
    return cliente ? JSON.parse(cliente) : undefined;
  }

  public static setCliente(cliente?: ICliente) {
    if (cliente) {
      sessionStorage.setItem('cliente', JSON.stringify(cliente));
    }
  }

  public static getTiposDispositivo(): TipoDispositivo[] {
    const user = this.getUsuario();
    const tiposDispositivo: TipoDispositivo[] = [];
    if (user) {
      const clientes = user.permisos.map((p) => p.cliente!);
      for (const cliente of clientes) {
        for (const tipo of cliente.tiposDispositivo) {
          if (!tiposDispositivo.includes(tipo)) {
            tiposDispositivo.push(tipo);
          }
        }
      }
    }
    return tiposDispositivo;
  }

  public static removeLoginInfo() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('usuario');
  }

  public static setLoginInfo(token: IToken) {
    sessionStorage.setItem('token', token.accessToken);
    sessionStorage.setItem('refreshToken', token.refreshToken || '');
    sessionStorage.setItem('usuario', JSON.stringify(token.user));
    const cliente = token.user.permisos[0].cliente;
    LoginService.setCliente(cliente);
  }

  // LOGIN

  public login(username: string, password: string): Observable<IToken> {
    return this.http.post<IToken>(`${api}/auth/login`, {
      username,
      password,
    });
  }

  public refreshToken(refresh_token: string): Observable<IToken> {
    return this.http.post<IToken>(`${api}/auth/refresh_token`, {
      refresh_token,
    });
  }
}
